<script lang="ts">
	// components
	import Button from '$components/utilities/Button.svelte';

	// icons
	import Add from 'carbon-icons-svelte/lib/Add.svelte';
	import Subtract from 'carbon-icons-svelte/lib/Subtract.svelte';

	// * required props *
	export let title: string;

	// optional props
	export let isExpandable = false;
	export let isPrimary = false;

	// state
	let isExpanded = false;
</script>

<li class={`transform list-none ${$$props.class ? $$props.class : ''}`}>
	<div
		class={`${
			isPrimary ? 'shadow-stack-primary border-cyan-500' : 'shadow-stack border-zinc-700'
		}  border-2 border-t-4 bg-zinc-900 p-3 md:p-5`}
	>
		<header class={isExpandable ? 'flex items-start justify-between md:items-center' : ''}>
			<h3
				class={`${
					isExpandable ? 'mt-1.5 md:mt-0' : ''
				} mono text-base font-black leading-6 text-white lg:text-lg`}
			>
				// {title}
			</h3>
			{#if isExpandable}
				<Button
					class="ml-3"
					icon={isExpanded ? Subtract : Add}
					kind="ghost"
					onClick={() => (isExpanded = !isExpanded)}
					title={isExpanded ? 'Collapse' : 'Expand'}
					tooltipAlignment="end"
					type="icon"
				/>
			{/if}
		</header>
		{#if !isExpandable || isExpanded}
			<div class="mt-3 text-base text-zinc-200">
				<slot name="description" />
			</div>
		{/if}
	</div>
</li>
